import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import VI from '../locales/vi';
import EN from '../locales/en';
import { NS } from '~/utils/ns';
import LanguageDetector from 'i18next-browser-languagedetector';

export const languages = [
  // {
  //   name: "แบบไทย",
  //   code: "th",
  //   icon: "/language/th.png",
  // },
  {
    name: 'English',
    code: 'en',
    icon: '/language/en.svg',
  },
  {
    name: 'Tiếng việt',
    code: 'vi',
    icon: '/language/vi.caa12196.svg',
  },
];

const resources = {
  vi: VI,
  en: EN,
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    ns: Object.values(NS),
    defaultNS: NS.common,
    supportedLngs: ['en', 'vi'],
    fallbackLng: 'vi',
    detection: {
      // Cấu hình các tùy chọn cho LanguageDetector
      order: ['localStorage', 'cookie', 'navigator'],
      caches: ['localStorage', 'cookie'],
    },
    interpolation: {
      escapeValue: false, // react already safes from xss
    },
  });

export default i18n;
